import { motion } from "framer-motion";
import portrait8 from "../assets/portrait8.jpeg";
import { Link } from "react-router-dom";

const WorkWithMe = () => {
  return (
    <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background with heavy fade */}
      <img
        src={portrait8}
        className="absolute inset-0 w-full h-full object-cover brightness-75"
        alt="Background"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-dreamy-cream via-dreamy-cream/40 to-transparent" />

      <div className="relative z-10 text-center px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="font-serif text-4xl md:text-6xl text-dreamy-earth mb-8"
        >
          Let’s capture your <span className="italic">forever</span>.
        </motion.h2>

        <Link to="/contact">
          <motion.button
            whileHover={{
              scale: 1.05,
              backgroundColor: "rgba(74, 63, 53, 1)",
              color: "#FFFDF5",
            }}
            className="px-10 py-4 border border-dreamy-earth text-dreamy-earth rounded-full font-sans text-xs tracking-[0.2em] uppercase transition-all duration-500"
          >
            Inquire for Sessions
          </motion.button>
        </Link>
      </div>
    </section>
  );
};

export default WorkWithMe;
